export default "/_next/static/images/f73294f7f51ebc853486adeec68ac0f0.jpg";